<div class="modal-header">
  <app-summary-top class="w-100" [header]="header()" [showSave]="false"></app-summary-top>
</div>

<div class="modal-body p-3" [innerHTML]="message()"></div>

<div class="modal-footer">
  <div class="d-flex mt-3">
    <button type="button" class="btn btn-primary" (click)="onOk()">{{ okLabel() }}</button>
  </div>
</div>
